// src/components/PrivateRoute.tsx
import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { CircularProgress } from "@mui/material";
import { useAppContext } from "../AppContext";

interface PrivateRouteProps {
  children: React.ReactNode;
  showModal?: boolean;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children, showModal }) => {
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState<any>(null);
  const location = useLocation();
  const auth = getAuth();
  const { user: contextUser } = useAppContext();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (firebaseUser) => {
      setUser(firebaseUser);
      setLoading(false);
    });

    return () => unsubscribe(); // Cleanup subscription
  }, [auth]);

  // If we're still loading, show loading spinner
  if (loading) {
    return <div className='flex w-full h-full items-center justify-center'><CircularProgress/></div>; 
  }

  // If we have a user in context or Firebase, allow access
  if (user || contextUser) {
    return children;
  }

  // Only redirect if we're not showing the modal and have no user
  if (!showModal && !user && !contextUser) {
    return (
      <Navigate
        to="/"
        state={{ showLogin: true, from: location }}
        replace
      />
    );
  }

  // If we're showing the modal, render children
  return children;
};

export default PrivateRoute;
